import { z } from '../zod.js';
/**
 * How a document opens from a mention, a link or a search (A2.1 section 7, fix 10): a side peek,
 * the full page, a centered peek, or beside the current page. Never a new browser tab.
 */
export const OPEN_MODES = ['peek', 'full', 'center', 'split'];
export const OpenMode = z.enum(OPEN_MODES);
/** The eighteen methods, in the order above. */
export const EDITOR_SERVICE_METHODS = [
    'searchDocs',
    'createStub',
    'getDoc',
    'getDocMeta',
    'resolveTitles',
    'listTypes',
    'uploadAsset',
    'rehostAsset',
    'subscribeSecretState',
    'subscribeDocChanged',
    'openDoc',
    'save',
    'updateMeta',
    'moveBlocks',
    'getSheet',
    'getRuleCard',
    'listSheets',
    'getCharacterSheet',
];
//# sourceMappingURL=services.js.map